import React, { useContext } from "react";
import UserContext from "../context/user-context";

type RoleProps = {
  children: JSX.Element;
  roles: string[];
  fallback?: JSX.Element | null;
};

const Role: React.FC<RoleProps> = ({ children, roles, fallback = null }) => {
  const user = useContext(UserContext);

  if (roles.some((role: string) => user?.roles.includes(role))) {
    return children;
  }
  return fallback;
};

export default Role;
